export const API_URL="https://66c188a6f83fffcb587986d6.mockapi.io/Products"
export const API="https://decoria-backend.onrender.com/api"